import React from "react";
import InfoCard from "src/components/InfoCard";
import Layout from "src/components/Layout";

const IMCA: React.FC = () => {
  return (
    <Layout>
      <InfoCard title={"IMCA Diving Certificates"} zeroPadding>
        <ul
          style={{
            color: "#000866",
            marginTop: "10px",
            marginBottom: "10px",
          }}
        >
          <li>Professional Diver’s Logbook Certificate</li>
          <li>Diving Supervisor’s Logbook Certificate</li>
          <li>Diving Superintendent’s Logbook Certificate</li>
          <li>Diving Inspection’s Logbook Certificate</li>
          <li>Technician’s Logbook Certificate</li>
          <li>Life Support Technician’s Logbook Certificate</li>
          <li>Beginner Diving Fitness certificate</li>
          <li>Certificat de Plongeur Professionnel</li>
        </ul>
      </InfoCard>
    </Layout>
  );
};

export default IMCA;
